import AddUserBox from "./AddUserBox";
import { MyContext } from "../context/myContext";
import { PersianToEnglish } from "numeral-convert";
import { useDispatch, useSelector } from "react-redux";
import {showPopUp, selectShowForm, selectAllCities,} from "../features/common-states/commonStatesSlice";

const UserSectionMenu = ({buttonText, formTitle, formComponent, initialInputState, initialSelectsState, initialState, getSearchedInfo, handleSearch, handleGetExcel,state={selectedValue: { term: "", city: "" }, input: "", emptyInputAlert: false, emptySelectAlert: false, isSearched: false,},setState=()=>{}}) => {
  const dispatch = useDispatch();
  const showForm = useSelector(selectShowForm);
  const allCities = useSelector(selectAllCities)
  const handleSelectChange = (e) => {
    let name = e.target.name;
    setState({...state, selectedValue: { ...state.selectedValue, [name]: e.target.value }, emptySelectAlert: false})
  }
  const handleInputChange = (e) => {
    const pattern = /^[\u0600-\u06FF\\a-zA-Z\s]+$/;
    const numberPattern = /^[0-9]+$/;
    if((state.selectedValue.term === "national_code" || state.selectedValue.term === "tanker_request_id") &&
       !numberPattern.test(PersianToEnglish(e.target.value)) && e.target.value !== "") {//To make user to enter just numbers
       return alert("کد ملی را بصورت صحیح با اعداد وارد کنید.");
    }
    if(state.selectedValue.term === "name" && !pattern.test(e.target.value) && e.target.value !== "") {
      //To make user to enter just alphabet
      return alert("نام را بصورت صحیح با حروف الفبا وارد کنید.");
    }
    setState({...state, input: PersianToEnglish(e.target.value), emptyInputAlert: false});
    if ((e.target.value === "" || e.target.value === " ") && state.isSearched) {
      //Get all data just when data are searched and input becomes empty.
      getSearchedInfo(""); //To get all data again when there is no value in input, after getting searched data(based on checking isSearched)
      setState({...state, input: PersianToEnglish(e.target.value), isSearched: false,}); //All data are shown, so don't call api again even if input becomes empty.
    }
  };
  const handleShowForm = () => {
    dispatch(showPopUp({ type: "showForm", value: !showForm }));
  };

  const handleSearchClick = () => {
    if (state.selectedValue.term === "") {
      setState({ ...state, emptySelectAlert: true });
    } else if (state.selectedValue.term !== "city_id" && state.input === "") {
      setState({ ...state, emptyInputAlert: true });
    } else {
      getSearchedInfo(state.selectedValue.term + "=" + (state.selectedValue.term === "city_id" ? state.selectedValue.city : state.input));
      setState({ ...state, isSearched: true }); // When data are searched, call api again if input becomes empty(in handleInputChange).
    }
  };

  return (
    <div className="user-section-menu flex flex-wrap gap-2 justify-between">
      {buttonText !== "افزودن کاربر" ? (
        <div className="search-part flex flex-wrap gap-1 items-center">
          {buttonText !== "افزودن درخواست" && (
            <button className="py-2 px-1 text-white text-xs bg-green-500 border-none rounded-md cursor-pointer" onClick={() => handleGetExcel(state.selectedValue.city)}>
              اکسل
            </button>
          )}
          <button className="cursor-pointer py-1 px-1 md:px-2 rounded-lg border border-1 border-gray-400 bg-whiteBg" onClick={handleSearchClick}>
            <i className="fa fa-search"></i>
          </button>
          {state.selectedValue.term === "city_id" ? (
              <div className='relative'>
                <select dir='rtl' name="city" className="select-styles" value={state.selectedValue.city} onChange={handleSelectChange}>
                  <option value="">همه شهرها</option>
                  {allCities.map((item, index) => {
                    return (
                        <option value={item.city_id} key={index}>
                          {item.name}
                        </option>
                    );
                  })}
                </select>
                <span className='double-select-arrow'></span>
              </div>
          ) : (
            <input type="text" className={`text-center w-[125px] sm:w-auto bg-whiteBg rounded-md border border-1 border-gray-300 outline-none transition-all duration-300
                   focus:shadow-focusShadow hover:border-green-500 text-[10px] sm:text-xs md:text-sm text-center py-2 tracking-wider ${state.emptyInputAlert ? "input-alert" : ""}`}
                   value={state.input} placeholder={`${buttonText === "افزودن درخواست" ? "کد پیگیری" : "کلمه کلیدی را وارد کنید"}`} onChange={handleInputChange}
            />
          )}
          {buttonText === "افزودن درخواست" ? (
            <div className='relative'>
              <select dir='rtl' name="term" id="select" className={`${state.emptySelectAlert ? "select-alert" : ""} select-styles`} onChange={handleSelectChange} defaultValue="جستجو بر اساس">
                <option disabled>جستجو بر اساس</option>
                <option value="tanker_request_id">کد پیگیری</option>
                <option value="city_id">شهر</option>
              </select>
              <span className='double-select-arrow'></span>
            </div>
          ) : (
            <div className='relative'>
              <select dir='rtl' name="term" id="select" className={`${state.emptySelectAlert ? "select-alert" : ""} select-styles`} onChange={handleSelectChange} defaultValue="جستجو بر اساس">
                <option disabled>جستجو بر اساس</option>
                <option value="national_code">کد ملی</option>
                <option value="name">نام</option>
                <option value="city_id">شهر</option>
              </select>
              <span className='double-select-arrow'></span>
            </div>
          )}
        </div>
      ) : (
        <div className="flex gap-2 items-center">
          <input type="text" className="input-styles py-1 focus:shadow-focusShadow focus:border-none w-[140px] sm:w-[200px]" value={state.input} onKeyUp={() => handleSearch(state.input)} onChange={handleInputChange}/>
          <label className='text-xs sm:text-sm'>:جستجو</label>
        </div>
      )}
      <button className="add-user-btn bg-green-500 text-white border-none rounded-lg ml-auto px-2 py-2 cursor-pointer text-[10px] md:text-sm filter hover:shadow-xl hover:contrast-125" onClick={handleShowForm}>
        {buttonText}
      </button>
      <MyContext.Provider value={{formTitle, showForm, handleShowForm, initialInputState, initialSelectsState, initialState,}}>
         <AddUserBox formComponent={formComponent} />
      </MyContext.Provider>
    </div>
  );
};

export default UserSectionMenu;
